export default {
    lang: {
        name: 'Date Rated'
    }
}